import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { combineLatest, of, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpsellProtectionGuard {
  constructor(
    private readonly router: Router,
    private readonly viewOffersService: ViewOffersService,
    private readonly additionalServicesService: AdditionalServicesService
  ) {}

  offers$ = this.viewOffersService.offers$;
  itemOfferError$ = this.additionalServicesService.itemOfferError$;
  itemOfferState$ = this.additionalServicesService.itemOfferState$;

  canActivate(next: ActivatedRouteSnapshot) {
    const PRRef = next.queryParams?.PRRef;

    combineLatest([this.offers$, this.itemOfferError$, this.itemOfferState$])
      .pipe(take(1))
      .subscribe(([offers, error, offerState]) => {
        if (offers) {
          const upsellReason = offers?.offer?.upsell_reason;
          if (
            offers?.offer?.upsell_flag &&
            !error &&
            ((upsellReason !== 'MULTIPLAN' && upsellReason !== 'EXCLUSION') ||
              !upsellReason) &&
            !offerState.skipped
          ) {
            return of(true);
          }

          this.router.navigate(['/complete-order'], {
            queryParams: { PRRef },
            replaceUrl: true,
          });
        }
      });

    return of(true);
  }
}
